<script lang="ts" setup>
import TrackPublicWrapper from "@/Pages/TrackPublic/TrackPublicWrapper.vue";
import { Head } from "@inertiajs/vue3";
import TrackPublicMap from "@/Pages/TrackPublic/Components/TrackPublicMap.vue";

interface Props {
    track: object;
}

// const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
    <TrackPublicWrapper>
        <Head>
            <title>Track map: {{ $page.props.track.name }}</title>

            <meta
                property="og:title"
                head-key="og:title"
                :content="`Track Map: ${$page.props.meta_track_name}`"
            />

            <meta
                name="robots"
                content="noindex, follow"
            />
        </Head>
        <template #map>
            <TrackPublicMap
                v-if="$page.props.track.latestVersion.distance > 0"
                :is-map-page="true"
                class="content-full-screen-height-mt-4 min-h-[50vh] flex-1 rounded-lg bg-white shadow-lg"
            />
            <div
                v-else
                class="mb-4 flex rounded-lg border border-red-300 bg-red-50 p-4 text-sm text-red-800"
                role="alert"
            >
                <svg
                    class="me-3 mt-[2px] inline size-4 shrink-0"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
                    />
                </svg>
                <div>
                    <span class="font-medium">No track file uploaded</span>
                    <div class="mt-2 text-sm">Please upload the track file to display the map here.</div>
                </div>
            </div>
        </template>
    </TrackPublicWrapper>
</template>
